import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable()
export class Autenticacao {

  tokenURL: string = environment.urlBackend + environment.obterTokenURL
  cadastrarFuncionarioURL: string = environment.urlBackend + environment.cadastrarUsuario
  loginURL: string = environment.urlBackend + environment.login
  loginAuth: string = environment.urlBackend + environment.loginAuthenticator;
  resetPassword: string = environment.urlBackend + environment.resetPassword

  clientID: string = environment.clientId
  clientSecret: string = environment.clientSecret
  errors: String[]
  loadingService: boolean

  public token_id: string

  constructor(
      private router: Router,
      private toastr: ToastrService,
      private http: HttpClient
  ){ }

  loginAuthenticator(token: string, usuaDsRe: string){

    const headers = {
      'Authorization' : 'Bearer ' + token,
      'Content-Type': 'application/json'
    };

    return this.http.post(this.loginAuth, {"usuaDsRe": usuaDsRe}, {headers: headers});
  }

  public autenticar(usuario: string, senha: string): Promise<any>{
      //this.router.navigate(['/home']);
      return this.tentarLogar(usuario, senha).toPromise().then((resposta:any) => resposta);
  }

  tentarLogar( userName: string, password: string ) :  Observable<any>{
      //PARAMETROS QUE VAI NO BODY DO POST
      const params = new HttpParams().set('username',  userName)
                                      .set('password', password)
                                      .set('grant_type', 'password');
      //HEADER PARA O POST
      const headers = {
          'Authorization' : 'Basic ' + btoa(`${this.clientID}:${this.clientSecret}`),
          'Content-Type' : 'application/x-www-form-urlencoded',
      }
      return this.http.post(this.tokenURL, params, { headers : headers }) ;
  }

  public login(usuario: string, senha: string): Promise<any>{

      return this.storageLogin(usuario, senha).toPromise().then((resposta:any) => resposta);
  }

  public novaSenha(usuario: string, senha: string): Promise<any>{
      //this.router.navigate(['/home']);
      return this.newPass(usuario, senha).toPromise().then((resposta:any) => resposta);
  }

  public newPass( userName: string, password: string ) :   Observable<any>{

    return this.http.get(this.resetPassword+"/"+userName+"/"+password);
  }

  public storageLogin( userName: string, password: string ) :   Observable<any>{

    //return this.http.post(this.tokenURL, params.toString, { headers : headers});
    return this.http.get(this.loginURL+"/"+userName+"/"+password);
  }

  public autenticado(): boolean{
      if(this.token_id === undefined && localStorage.getItem('access_token') !== null){
          this.token_id = localStorage.getItem('access_token')
      }else if (this.token_id === undefined && localStorage.getItem('access_token') == null){
          this.router.navigate(['/'])
      }
      return this.token_id !== undefined
  }

  public sair(): void {
    localStorage.clear();
    this.router.navigate([''])
  }

  public getUsuarioPorRe(re:string):Promise<any>{

    return this.http.get(environment.urlBackend + environment.getUsuario + "/" + re)
    .toPromise().then((resposta:any) => resposta);
  }
}
